module.exports = __webpack_public_path__ + "static/media/card5_1.5e371b11.png";